export default {
  'zh-HK': {
    '下载 App': '下載 App',
    '下载 UPlus App': '下載 UPlus App',
    '扫码或点击下载，随时随地管理你的量化策略。': '掃碼或點擊下載，隨時隨地管理你的量化策略。',
    '立即下载': '立即下載',
    'APK / 应用商店': 'APK / 應用商店',
    '下载 APK': '下載 APK',
    '请通过官方渠道下载，谨防山寨应用。': '請通過官方渠道下載，謹防山寨應用。',
    '关闭下载弹框': '關閉下載彈框'
  },
  en: {
    '下载 App': 'Download App',
    '下载 UPlus App': 'Download UPlus App',
    '扫码或点击下载，随时随地管理你的量化策略。': 'Scan or tap to download and manage your quant strategies anywhere.',
    '立即下载': 'Download now',
    'APK / 应用商店': 'APK / App stores',
    '下载 APK': 'Download APK',
    '请通过官方渠道下载，谨防山寨应用。': 'Download only from official channels to avoid fake apps.',
    '关闭下载弹框': 'Close download dialog'
  },
  ko: {
    '下载 App': 'App 다운로드',
    '下载 UPlus App': 'UPlus App 다운로드',
    '扫码或点击下载，随时随地管理你的量化策略。': '스캔하거나 탭해 다운로드하고 언제든 퀀트 전략을 관리하세요.',
    '立即下载': '지금 다운로드',
    'APK / 应用商店': 'APK / 앱스토어',
    '下载 APK': 'APK 다운로드',
    '请通过官方渠道下载，谨防山寨应用。': '공식 채널을 통해서만 다운로드해 가짜 앱을 피하세요.',
    '关闭下载弹框': '다운로드 창 닫기'
  }
}

